import { Box, Text, useTooltip } from '@modusign/design-system';
import { forwardRef } from 'react';

interface MousePositionTrackingTooltipProps {
  children: React.ReactNode;
  position: ReturnType<typeof useTooltip>['position'];
  top: ReturnType<typeof useTooltip>['top'];
  left: ReturnType<typeof useTooltip>['left'];
}

function MousePositionTrackingTooltip(
  { children, left, position, top }: MousePositionTrackingTooltipProps,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <Box
      backgroundColor="notificationBackgroundSecondaryUltraDark"
      borderRadius="6px"
      pb={3}
      pt={2}
      px={4}
      ref={ref}
      style={{ top, left }}
      sx={{ position, transform: 'translate(-50%, 0)' }}
    >
      <Box
        aria-hidden
        as="svg"
        color="notificationBackgroundSecondaryUltraDark"
        height="13px"
        sx={{ left: '50%', position: 'absolute', transform: 'translate(-50%, 160%) rotate(90deg)' }}
        viewBox="0 0 7 13"
        width="7"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M-1.5 12.5L-1.5 13.4641L-0.711941 12.9087L5.82125 8.30379C6.72625 7.66591 6.72625 6.33409 5.82125 5.69621L-0.711939 1.09132L-1.5 0.535857L-1.5 1.5L-1.5 12.5Z"
            fill="currentColor"
            stroke="#474747"
            strokeWidth={1}
          />
        </g>
      </Box>
      <Text
        color="textNeutralLightest"
        fontSize="12px"
        fontWeight="medium"
        sx={{ wordBreak: 'keep-all' }}
      >
        {children}
      </Text>
    </Box>
  );
}

export default forwardRef<HTMLDivElement, MousePositionTrackingTooltipProps>(
  MousePositionTrackingTooltip
);
